import {Component, OnDestroy, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {DataService} from '../services/dataService';
import {ActivatedRoute, Router} from '@angular/router';
import {Location} from '@angular/common';
import {
    ArbreMachine,
    CordovaUIService,
    FilterType,
    FilterValue,
    I18n,
    Machine,
    MoI18nService,
    RouleauNote,
    TravailMachine,
    TravailType,
    RouleauDoc as Doc, Rouleau
} from '../../common';
import {PageEnum} from '../entity';
import {FilterContentUI, FilterValueUI, FiltreUI, InfoUI, RouleauUI, TypeInfoEnum, TypeSolEnum, UtilisationEnum} from '../entity/';

export enum YesNoChoice {
    UNDEFINED = 0,
    NO = 1,
    YES = 2
}

@Component({
    selector   : 'app-filter',
    templateUrl: './filter.component.html',
    styleUrls  : ['./filter.component.scss']
})
export class FilterComponent implements OnInit, OnDestroy {
    /**
     * Is the show the filter part
     */
    private _isShowFilterPart: boolean = true;
    /**
     * Know lemken machine model
     */
    private _knowModel: YesNoChoice = YesNoChoice.YES;
    /**
     * IsShown type travail
     */
    private _isShowTypeTravailFilters: boolean = true;
    /**
     * IsShow machine
     */
    private _isShowMachineFilters: boolean = true;
    /**
     * Show param complementaires freinage
     */
    private _isShowParamCompFreinageFilters: boolean = false;
    /**
     * Has param freinage choices
     */
    private _hasParamFreinageChoices: boolean = false;
    /**
     * Show conseil pertinance utilisation
     */
    private _isShowConseilPertinanceFilters: boolean = false;
    /**
     * User Filter.
     */
    private _userFilter: FiltreUI;
    /**
     * Is Ready To show
     */
    private _isReadyToShow: boolean = false;
    /**
     * Filter resume.
     */
    private _filterResume: string = 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, ' +
        'sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.';
    /**
     * All Rouleaux
     */
    private allRouleaux: Array<RouleauUI> = [];
    /**
     * Freinage infos
     */
    private _rouleauxFreinageInfos: Map<string, string> = new Map();
    /**
     * Machine
     */
    private _machines: Array<Machine> = [];
    /**
     * Arbres Machines
     */
    private arbreMachines: Array<ArbreMachine> = [];
    /**
     * Arbres Travaux
     */
    private travailMachines: Array<TravailMachine> = [];
    /**
     * Filter Values
     */
    private filterValues: Array<FilterValue> = [];
    /**
     * I18ns Values
     */
    private i18nValues: Array<I18n> = [];
    /**
     * Key 2 I18n Values.
     */
    private key2I18nValues: { [key: string]: I18n; } = {};
    /**
     * Filtered rouleaux buffer
     * To be assigned to _filteredRouleaux on "Voir les rouleaux" click
     */
    private _filteredRouleauxBuffer: Array<RouleauUI> = [];
    public get filteredRouleauxBuffer(): Array<RouleauUI> {
        return this._filteredRouleauxBuffer;
    }
    /**
     * Filtered Rouleaux
     */
    private _filteredRouleaux: Array<RouleauUI> = [];
    /**
     * Type Sol List
     */
    private _typeSolList: Array<TypeSolEnum> = [TypeSolEnum.SOL_LOURD, TypeSolEnum.SOL_MOYEN, TypeSolEnum.SOL_LEGER];
    /**
     * Type Trvail List
     */
    private _typeTravailList: Array<TravailType> = [TravailType.TRAVAIL_DENT, TravailType.TRAVAIL_DISQUE, TravailType.TRAVAIL_HERSE];
    /**
     * Utilisation List
     */
    private _utilisationList: Array<UtilisationEnum> = [
        UtilisationEnum.RAPPUYAGE_LIGNE,
        UtilisationEnum.INSENSIBLE_COLLAGE,
        UtilisationEnum.INSENSIBLE_PIERRE,
        UtilisationEnum.NIVELLEMENT,
        UtilisationEnum.PROFONDEUR,
        UtilisationEnum.RAPPUYAGE,
        UtilisationEnum.ROULAGE,
        UtilisationEnum.EMIETTEMENT
    ];

    /**
     * Get Notes
     * @param notes
     * @param typeSol
     * @param utilisation
     */
    private static getNote(notes: RouleauNote, typeSol: TypeSolEnum, utilisation: UtilisationEnum): number {
        let res = 0;
        switch (utilisation) {
            case UtilisationEnum.RAPPUYAGE_LIGNE:
                switch (typeSol) {
                    case TypeSolEnum.SOL_LOURD:
                        res = notes.solLourdRappuyageLigne;
                        break;
                    case TypeSolEnum.SOL_MOYEN:
                        res = notes.solMoyenRappuyageLigne;
                        break;
                    case TypeSolEnum.SOL_LEGER:
                        res = notes.solLegerRappuyageLigne;
                        break;
                    case TypeSolEnum.MOYENNE:
                        res = notes.generalRappuyageLigne;
                        break;
                }
                break;
            case UtilisationEnum.INSENSIBLE_COLLAGE:
                switch (typeSol) {
                    case TypeSolEnum.SOL_LOURD:
                        res = notes.solLourdInsCollage;
                        break;
                    case TypeSolEnum.SOL_MOYEN:
                        res = notes.solMoyenInsCollage;
                        break;
                    case TypeSolEnum.SOL_LEGER:
                        res = notes.solLegerInsCollage;
                        break;
                    case TypeSolEnum.MOYENNE:
                        res = notes.generalInsCollage;
                        break;
                }
                break;
            case UtilisationEnum.INSENSIBLE_PIERRE:
                switch (typeSol) {
                    case TypeSolEnum.SOL_LOURD:
                        res = notes.solLourdInsPierres;
                        break;
                    case TypeSolEnum.SOL_MOYEN:
                        res = notes.solMoyenInsPierres;
                        break;
                    case TypeSolEnum.SOL_LEGER:
                        res = notes.solLegerInsPierres;
                        break;
                    case TypeSolEnum.MOYENNE:
                        res = notes.generalInsPierres;
                        break;
                }
                break;
            case UtilisationEnum.NIVELLEMENT:
                switch (typeSol) {
                    case TypeSolEnum.SOL_LOURD:
                        res = notes.solLourdNivellement;
                        break;
                    case TypeSolEnum.SOL_MOYEN:
                        res = notes.solMoyenNivellement;
                        break;
                    case TypeSolEnum.SOL_LEGER:
                        res = notes.solLegerNivellement;
                        break;
                    case TypeSolEnum.MOYENNE:
                        res = notes.generalNivellement;
                        break;
                }
                break;
            case UtilisationEnum.PROFONDEUR:
                switch (typeSol) {
                    case TypeSolEnum.SOL_LOURD:
                        res = notes.solLourdCtrlProf;
                        break;
                    case TypeSolEnum.SOL_MOYEN:
                        res = notes.solMoyenCtrlProf;
                        break;
                    case TypeSolEnum.SOL_LEGER:
                        res = notes.solLegerCtrlProf;
                        break;
                    case TypeSolEnum.MOYENNE:
                        res = notes.generalCtrlProf;
                        break;
                }
                break;
            case UtilisationEnum.RAPPUYAGE:
                switch (typeSol) {
                    case TypeSolEnum.SOL_LOURD:
                        res = notes.solLourdRappuyage;
                        break;
                    case TypeSolEnum.SOL_MOYEN:
                        res = notes.solMoyenRappuyage;
                        break;
                    case TypeSolEnum.SOL_LEGER:
                        res = notes.solLegerRappuyage;
                        break;
                    case TypeSolEnum.MOYENNE:
                        res = notes.generalRappuyage;
                        break;
                }
                break;
            case UtilisationEnum.ROULAGE:
                switch (typeSol) {
                    case TypeSolEnum.SOL_LOURD:
                        res = notes.solLourdRoulage;
                        break;
                    case TypeSolEnum.SOL_MOYEN:
                        res = notes.solMoyenRoulage;
                        break;
                    case TypeSolEnum.SOL_LEGER:
                        res = notes.solLegerRoulage;
                        break;
                    case TypeSolEnum.MOYENNE:
                        res = notes.generalRoulage;
                        break;
                }
                break;
            case UtilisationEnum.EMIETTEMENT:
                switch (typeSol) {
                    case TypeSolEnum.SOL_LOURD:
                        res = notes.solLourdEmiettement;
                        break;
                    case TypeSolEnum.SOL_MOYEN:
                        res = notes.solMoyenEmiettement;
                        break;
                    case TypeSolEnum.SOL_LEGER:
                        res = notes.solLegerEmiettement;
                        break;
                    case TypeSolEnum.MOYENNE:
                        res = notes.generalEmiettement;
                        break;
                }
                break;
        }
        return res;
    }

    /**
     * Constructor
     * @param translate
     * @param dataService
     * @param router
     * @param route
     * @param location
     * @param cordovaService
     */
    constructor(private translate: TranslateService,
                private dataService: DataService,
                private router: Router,
                private route: ActivatedRoute,
                private location: Location,
                private cordovaService: CordovaUIService) {
    }


    /**
     * NgOnInit
     */
    public ngOnInit() {
        console.log('OnInit FilterComponent');
        this.dataService.cleanNewPage();
        this.translate.get('filterPage.pageTitle').subscribe(
            (res: string) => {
                this.dataService.publishNewPageTitle(PageEnum.FILTER, res);
            }
        );
        const promiseR = this.dataService.getRouleauxUI();
        const promiseM = this.dataService.getMachines();
        const promiseAM = this.dataService.getArbreMachines();
        const promiseAT = this.dataService.getTravailMachines();
        const promiseFV = this.dataService.getFilterValues();
        const promiseI = this.dataService.getI18ns();

        promiseR.then(
            (res) => {
                this.allRouleaux = res;
            },
            () => {
                // TODO Afficher une erreur
            }
        );
        promiseM.then(
            (res) => {
                this._machines = res;
            },
            () => {
                // TODO Afficher une erreur
            }
        );
        promiseAM.then(
            (res) => {
                this.arbreMachines = res;
            },
            () => {
                // TODO Afficher une erreur
            }
        );
        promiseAT.then(
            (res) => {
                this.travailMachines = res;
            },
            () => {
                // TODO Afficher une erreur
            }
        );
        promiseFV.then(
            (res) => {
                this.filterValues = res;
            },
            () => {
                // TODO Afficher une erreur
            }
        );
        promiseI.then(
            (res) => {
                this.i18nValues = res;
                const i18ns = this.i18nValues.filter(value => value.lang === MoI18nService.DEFAULT_LANG);
                for (const i18n of i18ns) {
                    this.key2I18nValues[i18n.code] = i18n;
                }
            },
            () => {
                // TODO Afficher une erreur
            }
        );
        Promise.all([promiseR, promiseM, promiseAM, promiseAT, promiseFV, promiseI])
            .then(
                () => {
                    this._userFilter = this.dataService.userFilter;
                    this.initFilter();
                },
                () => {
                    // Cas d'erreur
                    this._userFilter = this.dataService.userFilter;
                    this.initFilter();
                }
            );
    }

    /**
     * NgOnDestroy
     */
    public ngOnDestroy() {
        console.log('OnDestroy FilterComponent');
    }

    /**
     * Init the filter.
     */
    private initFilter() {
        this.computeFilter();
        this.computeRouleauxFreinageInfos(this.allRouleaux);
        this._isReadyToShow = true;
        this.computeFreinageBlockVisibility();
    }

    /**
     * Compute brake infos (oui / non / à preciser)
     */
    private computeRouleauxFreinageInfos(rouleaux: Array<RouleauUI>) {
        rouleaux.forEach(
            oneRouleau => {
                if (oneRouleau.arbreMachines.length > 0) {
                    const allSameFreinage = oneRouleau.arbreMachines.every(
                        value => value.freinage === oneRouleau.arbreMachines[0].freinage
                    );

                    let brakeInfos = this.translate.instant('filterPage.yes');
                    if (allSameFreinage) {
                        if (!oneRouleau.arbreMachines[0].freinage) {
                            brakeInfos = this.translate.instant('filterPage.no');
                        }
                    } else {
                        brakeInfos = this.translate.instant('filterPage.selonConfiguration');
                    }

                    this._rouleauxFreinageInfos.set(oneRouleau.rouleau.code, brakeInfos);
                } else {
                    this._rouleauxFreinageInfos.set(oneRouleau.rouleau.code, this.translate.instant('filterPage.selonConfiguration'));
                }
            }
        );
    }

    public getFreinageInfosFor(rouleauCode: string): string {
        return this._rouleauxFreinageInfos.get(rouleauCode);
    }

    /**
     * Compute the filters
     */
    private computeFilter() {
        this._filterResume = '';
        if (this._userFilter.typeTravail != null) {
            let colName: string = 'travailDisqueFilter';
            let colType: FilterType = FilterType.TRAVAIL_DENT;
            switch (this._userFilter.typeTravail) {
                case TravailType.TRAVAIL_DENT:
                    colName = 'travailDentFilter';
                    colType = FilterType.TRAVAIL_DENT;
                    this._userFilter.travailDentFilter.isFilter = true;
                    this._userFilter.travailDisqueFilter.isFilter = false;
                    this._userFilter.travailHerseFilter.isFilter = false;
                    this._userFilter.travailDisqueFilter.selectedCode = null;
                    this._userFilter.travailHerseFilter.selectedCode = null;
                    break;
                case TravailType.TRAVAIL_HERSE:
                    colName = 'travailHerseFilter';
                    colType = FilterType.TRAVAIL_HERSE;
                    this._userFilter.travailHerseFilter.isFilter = true;
                    this._userFilter.travailDisqueFilter.isFilter = false;
                    this._userFilter.travailDentFilter.isFilter = false;
                    this._userFilter.travailDisqueFilter.selectedCode = null;
                    this._userFilter.travailDentFilter.selectedCode = null;
                    break;
                case TravailType.TRAVAIL_DISQUE:
                    colName = 'travailDisqueFilter';
                    colType = FilterType.TRAVAIL_DISQUE;
                    this._userFilter.travailDisqueFilter.isFilter = true;
                    this._userFilter.travailHerseFilter.isFilter = false;
                    this._userFilter.travailDentFilter.isFilter = false;
                    this._userFilter.travailHerseFilter.selectedCode = null;
                    this._userFilter.travailDentFilter.selectedCode = null;
                    break;
            }
            const filterValues: Array<FilterValue> = this.filterValues
                .filter(value => value.filterType === colType);
            const filterValueUIs: Array<FilterValueUI> = [];
            for (const filterVal of filterValues) {
                const filterValueUI: FilterValueUI = {
                    filterValue: filterVal,
                    label      : filterVal.code
                };
                if (this.key2I18nValues[filterVal.codeI18n] != null) {
                    filterValueUI.label = this.key2I18nValues[filterVal.codeI18n].label;
                }
                filterValueUIs.push(filterValueUI);
            }
            filterValueUIs.sort((a, b) => a.filterValue.rang - b.filterValue.rang);
            // @ts-ignore
            this._userFilter[colName].codeValues = filterValueUIs;
        } else {
            this._userFilter.travailDentFilter.isFilter = false;
            this._userFilter.travailDisqueFilter.isFilter = false;
            this._userFilter.travailHerseFilter.isFilter = false;
            this._userFilter.travailDentFilter.selectedCode = null;
            this._userFilter.travailDisqueFilter.selectedCode = null;
            this._userFilter.travailHerseFilter.selectedCode = null;
        }

        if (this._userFilter.isFilterByMachine) {
            this._userFilter.filteredMachines = this.machines;
        } else {
            let filteredMachines: Array<Machine> = this._machines;
            for (const item of [
                {
                    type  : TravailType.TRAVAIL_DENT,
                    filter: this._userFilter.travailDentFilter
                },
                {
                    type  : TravailType.TRAVAIL_DISQUE,
                    filter: this._userFilter.travailDisqueFilter
                },
                {
                    type  : TravailType.TRAVAIL_HERSE,
                    filter: this._userFilter.travailHerseFilter
                },
            ]) {
                // Filter by type travail and code travail if a code travail has been selected or code travail only if no code travail
                if (item.filter.isFilter) {
                    if (item.filter.selectedCode != null && item.filter.selectedCode !== '') {
                        const travailMachinesCodes = new Set<string>(
                            this.travailMachines.filter(
                                value => value.typeTravail === item.type && value.codeTravail === item.filter.selectedCode
                            ).map(value => value.codeMachine));
                        filteredMachines = filteredMachines.filter(
                            value => travailMachinesCodes.has(value.code)
                        );
                    } else {
                        const travailMachinesCodes = new Set<string>(
                            this.travailMachines.filter(value => value.typeTravail === item.type).map(value => value.codeMachine)
                        );
                        filteredMachines = filteredMachines.filter(
                            value => travailMachinesCodes.has(value.code)
                        );
                    }
                }
            }
            this._userFilter.filteredMachines = filteredMachines;
            if (this._userFilter.filteredMachines.length === 1) {
                this._userFilter.codeMachine = this._userFilter.filteredMachines[0].code;
            }
        }

        if (this._userFilter.codeMachine == null || this._userFilter.codeMachine.length === 0 ||
            !this._userFilter.filteredMachines.some(value => value.code === this._userFilter.codeMachine)) {
            for (const filter of [
                this._userFilter.porteFilter,
                this._userFilter.largeurFilter,
                this._userFilter.chassisFilter,
                this._userFilter.timonFilter,
                this._userFilter.herseFilter,
                this._userFilter.roueFilter,
                this._userFilter.semoirFilter
            ]) {
                filter.selectedCode = null;
                filter.isFilter = null;
            }
            this._userFilter.codeMachine = null;
        }
        let arbreMachinesFiltered: Array<ArbreMachine> = null;
        let haveMachine: boolean = false;
        if (this._userFilter.codeMachine != null && this._userFilter.codeMachine.length > 0) {
            arbreMachinesFiltered = this.arbreMachines
                .filter(value => value.codeMachine === this._userFilter.codeMachine && value.compatible);
            const machine: Machine = this._machines.find(value => value.code === this._userFilter.codeMachine);
            if (machine != null) {
                this._filterResume = machine.nom;
            }
            haveMachine = true;
        } else {
            const codeMachinesSet = new Set(this._userFilter.filteredMachines
                .map(value => value.code));
            arbreMachinesFiltered = this.arbreMachines.filter(value => codeMachinesSet.has(value.codeMachine));
        }

        this.computeFilterContentCreate(
            this._userFilter.porteFilter,
            arbreMachinesFiltered,
            'codePorte',
            FilterType.PORTE,
            haveMachine
        );
        this.computeFilterContentCreate(
            this._userFilter.largeurFilter,
            arbreMachinesFiltered,
            'codeLargeur',
            FilterType.LARGEUR,
            haveMachine
        );
        this.computeFilterContentCreate(
            this._userFilter.chassisFilter,
            arbreMachinesFiltered,
            'codeChassis',
            FilterType.CHASSIS,
            haveMachine
        );
        this.computeFilterContentCreate(
            this._userFilter.timonFilter,
            arbreMachinesFiltered,
            'codeTimon',
            FilterType.TIMON,
            haveMachine
        );
        this.computeFilterContentCreate(
            this._userFilter.herseFilter,
            arbreMachinesFiltered,
            'codeHerse',
            FilterType.HERSE,
            haveMachine
        );
        this.computeFilterContentCreate(
            this._userFilter.roueFilter,
            arbreMachinesFiltered,
            'codeRoue',
            FilterType.ROUE,
            haveMachine
        );
        this.computeFilterContentCreate(
            this._userFilter.semoirFilter,
            arbreMachinesFiltered,
            'codeSemoir',
            FilterType.SEMOIR,
            haveMachine
        );

        arbreMachinesFiltered = this.computeFilterContentDo(this._userFilter.porteFilter,
            arbreMachinesFiltered,
            'codePorte');
        arbreMachinesFiltered = this.computeFilterContentDo(this._userFilter.largeurFilter,
            arbreMachinesFiltered,
            'codeLargeur');
        arbreMachinesFiltered = this.computeFilterContentDo(this._userFilter.chassisFilter,
            arbreMachinesFiltered,
            'codeChassis');
        arbreMachinesFiltered = this.computeFilterContentDo(this._userFilter.timonFilter,
            arbreMachinesFiltered,
            'codeTimon');
        arbreMachinesFiltered = this.computeFilterContentDo(this._userFilter.herseFilter,
            arbreMachinesFiltered,
            'codeHerse');
        arbreMachinesFiltered = this.computeFilterContentDo(this._userFilter.roueFilter,
            arbreMachinesFiltered,
            'codeRoue');
        arbreMachinesFiltered = this.computeFilterContentDo(this._userFilter.semoirFilter,
            arbreMachinesFiltered,
            'codeSemoir');

        if (this._userFilter.sols.length > 0) {
            this._filterResume = this._filterResume + ' /' + this.translate.instant('filterPage.typeSol');
            for (const sol of this._userFilter.sols) {
                this._filterResume = this._filterResume + ' ' + this.translate.instant('filterPage.' + sol);
            }
        }
        if (this._userFilter.utilisations1.length > 0) {
            this._filterResume = this._filterResume + ' / ' + this.translate.instant('filterPage.use1');
            for (const sol of this._userFilter.utilisations1) {
                this._filterResume = this._filterResume + ' ' + this.translate.instant('filterPage.' + sol);
            }
        }
        if (this._userFilter.utilisations2.length > 0) {
            this._filterResume = this._filterResume + ' / ' + this.translate.instant('filterPage.use2');
            for (const sol of this._userFilter.utilisations2) {
                this._filterResume = this._filterResume + ' ' + this.translate.instant('filterPage.' + sol);
            }
        }
        const codeRouleauCompatible: Set<string> = new Set(arbreMachinesFiltered.map(value => value.codeRouleau));
        const tempFiltreredRouleaux: Array<RouleauUI> = [];
        for (const rouleau of this.allRouleaux) {
            if (codeRouleauCompatible.has(rouleau.rouleau.code)) {
                tempFiltreredRouleaux.push(rouleau);
                rouleau.arbreMachines = arbreMachinesFiltered.filter(value => value.codeRouleau === rouleau.rouleau.code);
                this.computeTranslateRouleauInfoForMachine(rouleau);
                let note1: number = 0;
                let note2: number = 0;
                for (const sol of this._userFilter.sols) {
                    for (const utilisation of this._userFilter.utilisations1) {
                        note1 += FilterComponent.getNote(rouleau.note, sol, utilisation);
                    }
                    for (const utilisation of this._userFilter.utilisations2) {
                        note2 += FilterComponent.getNote(rouleau.note, sol, utilisation);
                    }
                }
                rouleau.score = note1 * this.dataService.userPreferences.ponderationUtilisation1
                    + note2 * this.dataService.userPreferences.ponderationUtilisation2;
            } else {
                rouleau.score = 0;
                rouleau.arbreMachines = [];
                rouleau.infos = [];
            }
        }
        tempFiltreredRouleaux.sort((a, b) => b.score - a.score);
        let maxRealise: number = -1;
        if (tempFiltreredRouleaux.length > 0) {
            maxRealise = tempFiltreredRouleaux[0].score;
        }
        const maxPossible = this._userFilter.sols.length * 2 *
            (this.dataService.userPreferences.ponderationUtilisation1 * this._userFilter.utilisations1.length +
                this.dataService.userPreferences.ponderationUtilisation2 * this._userFilter.utilisations2.length);


        let coeffRectificatif: number = 1;
        if (maxRealise / maxPossible < 0.8) {
            coeffRectificatif = 0.8 * maxPossible / maxRealise;
        }
        if (maxPossible === 0) {
            for (const tempFiltreredRouleau of tempFiltreredRouleaux) {
                tempFiltreredRouleau.percentage = 100;
            }
        } else {
            for (const tempFiltreredRouleau of tempFiltreredRouleaux) {
                tempFiltreredRouleau.percentage = Math.round(coeffRectificatif *
                    (tempFiltreredRouleau.score / maxPossible) * 100);
            }
        }

        // this._filteredRouleaux = tempFiltreredRouleaux;
        this._filteredRouleauxBuffer = tempFiltreredRouleaux;
        this.computeRouleauxFreinageInfos(this._filteredRouleauxBuffer);
    }

    /**
     * Assign _filteredRouleauxBuffer to _filteredRouleaux to be displayed
     */
    public displayFilteredRouleaux() {
        this._filteredRouleaux = this._filteredRouleauxBuffer;
    }

    /**
     * Create the value in the filter Content
     * @param filterContent
     * @param arbreMachinesFiltered
     * @param attribut
     * @param filterType
     * @param haveMachine
     */
    private computeFilterContentCreate(filterContent: FilterContentUI,
                                       arbreMachinesFiltered: Array<ArbreMachine>,
                                       attribut: string,
                                       filterType: FilterType,
                                       haveMachine: boolean) {
        // @ts-ignore
        const codeValues: Set<string> = new Set(arbreMachinesFiltered.map(value => value[attribut])
            .filter(value => value != null && value !== ''));
        if (codeValues.size > 0) {
            filterContent.isFilter = true;
            let filterValues: Array<FilterValue>;
            if (haveMachine) {
                filterValues = this.filterValues
                    .filter(value => value.filterType === filterType)
                    .filter(value => codeValues.has(value.code));
            } else {
                filterValues = this.filterValues
                    .filter(value => value.filterType === filterType);
            }
            const filterValueUIs: Array<FilterValueUI> = [];
            for (const filterVal of filterValues) {
                const filterValueUI: FilterValueUI = {
                    filterValue: filterVal,
                    label      : filterVal.code
                };
                if (this.key2I18nValues[filterVal.codeI18n] != null) {
                    filterValueUI.label = this.key2I18nValues[filterVal.codeI18n].label;
                }
                filterValueUIs.push(filterValueUI);
            }
            filterValueUIs.sort((a, b) => a.filterValue.rang - b.filterValue.rang);
            filterContent.codeValues = filterValueUIs;
        } else {
            filterContent.isFilter = false;
            filterContent.codeValues = [];
        }
    }

    /**
     * Do the filter with a filter Content
     * @param filterContent
     * @param arbreMachinesFiltered
     * @param attribut
     */
    private computeFilterContentDo(filterContent: FilterContentUI,
                                   arbreMachinesFiltered: Array<ArbreMachine>,
                                   attribut: string): Array<ArbreMachine> {
        let res: Array<ArbreMachine> = arbreMachinesFiltered;
        if (filterContent.isFilter
            && filterContent.codeValues.length > 1
            && filterContent.selectedCode != null
            && filterContent.selectedCode !== ''
            && filterContent.codeValues.some(value => value.filterValue.code === filterContent.selectedCode)
        ) {
            // @ts-ignore
            res = arbreMachinesFiltered.filter(value => value[attribut] === filterContent.selectedCode || !value[attribut]);
            const filterValueUI = filterContent.codeValues.find(value => value.filterValue.code === filterContent.selectedCode);
            if (filterValueUI != null) {
                this._filterResume = this._filterResume + ' / ' + this.translate.instant(filterContent.labelCode) + ' ' +
                    filterValueUI.label;
            }
        }
        return res;
    }

    /**
     * Create the translation for a rouleau with the arbre (case Machine Filter)
     * @param rouleau rouleau to translate
     */
    private computeTranslateRouleauInfoForMachine(rouleau: RouleauUI): void {
        rouleau.infos = [];
        rouleau.arbreMachines.sort((a, b) => a.codeLargeur.localeCompare(b.codeLargeur));
        for (const arbreMachine of rouleau.arbreMachines) {
            const newTabInfo = [];
            const machine: Machine = this._machines.find(value => value.code === arbreMachine.codeMachine);
            if (machine != null) {
                newTabInfo.push({
                    type : TypeInfoEnum.INFO,
                    label: this.translate.instant('filterPage.machine'),
                    value: machine.nom
                });
            }
            this.computeTranslateRouleauInfoForMachineInternal(newTabInfo, arbreMachine.codePorte, this._userFilter.porteFilter);
            this.computeTranslateRouleauInfoForMachineInternal(newTabInfo, arbreMachine.codeLargeur, this._userFilter.largeurFilter);
            this.computeTranslateRouleauInfoForMachineInternal(newTabInfo, arbreMachine.codeChassis, this._userFilter.chassisFilter);
            this.computeTranslateRouleauInfoForMachineInternal(newTabInfo, arbreMachine.codeTimon, this._userFilter.timonFilter);
            this.computeTranslateRouleauInfoForMachineInternal(newTabInfo, arbreMachine.codeHerse, this._userFilter.herseFilter);
            this.computeTranslateRouleauInfoForMachineInternal(newTabInfo, arbreMachine.codeRoue, this._userFilter.roueFilter);
            this.computeTranslateRouleauInfoForMachineInternal(newTabInfo, arbreMachine.codeSemoir, this._userFilter.semoirFilter);

            if (arbreMachine.remarqueI18n != null && arbreMachine.remarqueI18n !== ''
                && this.key2I18nValues[arbreMachine.remarqueI18n] != null) {
                newTabInfo.push({
                    type : TypeInfoEnum.INFO,
                    label: this.key2I18nValues[arbreMachine.remarqueI18n].label,
                    value: this.key2I18nValues[arbreMachine.remarqueI18n].description
                });
            }

            let breakInfo = this.translate.instant('filterPage.yes');
            let styleType: TypeInfoEnum = TypeInfoEnum.DANGER;
            if (!arbreMachine.freinage) {
                breakInfo = this.translate.instant('filterPage.no');
                styleType = TypeInfoEnum.INFO;
            }
            newTabInfo.push({
                type : styleType,
                label: this.translate.instant('filterPage.requiredBrake'),
                value: breakInfo
            });

            rouleau.infos.push(newTabInfo);
        }
    }

    /**
     * Internal Method to transalte
     * @param tab
     * @param code
     * @param filterContentUi
     */
    private computeTranslateRouleauInfoForMachineInternal(tab: Array<InfoUI>, code: string, filterContentUi: FilterContentUI): void {
        if (code != null) {
            const infoLabel: string = this.translate.instant(filterContentUi.labelCode);
            const filterValueUI = filterContentUi.codeValues.find(value => value.filterValue.code === code);
            if (filterValueUI != null) {
                tab.push({
                    type : TypeInfoEnum.INFO,
                    label: infoLabel,
                    value: filterValueUI.label
                });
            }
        }
    }

    /**
     * Reset Filter
     */
    public resetFilter(): void {
        this._userFilter.typeTravail = null;
        for (const filter of [
            this._userFilter.travailHerseFilter,
            this._userFilter.travailDisqueFilter,
            this._userFilter.travailDentFilter
        ]) {
            filter.selectedCode = null;
            filter.isFilter = false;
        }

        this._userFilter.codeMachine = null;
        for (const filter of [
            this._userFilter.porteFilter,
            this._userFilter.largeurFilter,
            this._userFilter.chassisFilter,
            this._userFilter.timonFilter,
            this._userFilter.herseFilter,
            this._userFilter.roueFilter,
            this._userFilter.semoirFilter
        ]) {
            filter.selectedCode = null;
            filter.isFilter = false;
        }
        this._userFilter.sols = [];
        this._userFilter.utilisations1 = [];
        this._userFilter.utilisations2 = [];
        this.eventSelectMachine();

        this.isShowConseilPertinanceFilters = false;
        this._filteredRouleauxBuffer = [];
        this._filteredRouleaux = [];
        this.hasParamFreinageChoices = false;
    }

    /**
     * Choose the filter by machine.
     */
    public chooseFilterByMachine(): void {
        this._userFilter.isFilterByMachine = true;
        this.computeFilter();
        this.dataService.saveUserFilter(this._userFilter);
    }


    /**
     * Choose the filter by machine.
     */
    public chooseFilterByWork(): void {
        this._userFilter.isFilterByMachine = false;
        this.computeFilter();
        this.dataService.saveUserFilter(this._userFilter);
    }

    /**
     * Choose know model
     */
    public knowModelChoice(knowModel: boolean) {
        this.resetFilter();
        this.knowModel = knowModel ? YesNoChoice.YES : YesNoChoice.NO;
        if (knowModel) {
            this.chooseFilterByMachine();
        } else {
            this.chooseFilterByWork();
        }
    }

    /**
     * Hide or Show the filter part
     */
    public hideOrShowFilterPart(): void {
        this._isShowFilterPart = !this._isShowFilterPart;
    }

    /**
     * Getter the ShowFilterPart
     */
    public get isShowFilterPart(): boolean {
        return this._isShowFilterPart;
    }

    /**
     * Getter the user filter.
     */
    public get userFilter(): FiltreUI {
        return this._userFilter;
    }

    /**
     * Filter resume
     */
    public get filterResume(): string {
        return this._filterResume;
    }

    /**
     * Get the filtered Rouleaux
     */
    public get filteredRouleaux(): Array<RouleauUI> {
        return this._filteredRouleaux;
    }

    /**
     * Add the rouleau  in the selection
     * @param rouleau
     */
    public addSelection(rouleau: RouleauUI): void {
        rouleau.selected = true;
        this.dataService.addSelection(rouleau.rouleau.code);
    }

    /**
     * Remove the rouleau in the selection
     * @param rouleau
     */
    public removeSelection(rouleau: RouleauUI): void {
        rouleau.selected = false;
        this.dataService.removeSelection(rouleau.rouleau.code);
    }

    /**
     * Getter on ready to show
     */
    public get isReadyToShow(): boolean {
        return this._isReadyToShow;
    }

    /**
     * Getter on the machine list
     */
    public get machines(): Array<Machine> {
        return this._machines;
    }

    /**
     * Event change Select Machine
     */
    public eventSelectMachine(computeFreinageBlockVisibility: boolean = false): void {
        this.dataService.saveUserFilter(this._userFilter);
        this.computeFilter();
        if (computeFreinageBlockVisibility) {
            this.computeFreinageBlockVisibility();
        }
    }

    /**
     * Getter Type Sol
     */
    public get typeSolList(): Array<TypeSolEnum> {
        return this._typeSolList;
    }

    /**
     * Getter Type Travail
     */
    public get typeTravailList(): Array<TravailType> {
        return this._typeTravailList;
    }

    /**
     * Getter Utilisation
     */
    public get utilisationList(): Array<UtilisationEnum> {
        return this._utilisationList;
    }

    /**
     * Show Vieu Detail for the rouleau
     * @param rouleau rouleau to view Detail
     */
    public showViewDetail(rouleau: RouleauUI): void {
        rouleau.viewDetail = true;
        setTimeout(this.scrollDetail.bind(this, rouleau.rouleau.uuid), 0);
    }

    /**
     * Scroll to the detail
     * @param rouleauUuid
     */
    private scrollDetail(rouleauUuid: string): void {
        const elementById = document.getElementById('rouleau' + rouleauUuid);
        if (elementById !== null) {
            elementById.scrollIntoView({behavior: 'smooth', block: 'start', inline: 'nearest'});
        } else {
            setTimeout(this.scrollDetail.bind(this, rouleauUuid), 100);
        }
    }

    /**
     * Type travail filter block expanded or not
     */
    public typeTravailFilterBlockExpanded(): boolean {
        return this.isShowFilterPart && this.isShowTypeTravailFilters && this.knowModel === 1;
    }

    /**
     * Has selected a type travail
     */
    public hasSelectedTypeTravail(): boolean {
        return (
            this.userFilter.travailDentFilter.isFilter
            || this.userFilter.travailDisqueFilter.isFilter
            || this.userFilter.travailHerseFilter.isFilter
        );
    }

    /**
     * Has selected type travail details
     */
    public hasSelectedTypeTravailDetails(): boolean {
        return (
            this.userFilter.travailDentFilter.selectedCode != null
            || this.userFilter.travailDisqueFilter.selectedCode != null
            || this.userFilter.travailHerseFilter.selectedCode != null
        );
    }

    /**
     * Machine filter block visibility
     */
    public isVisibleMachineFilterBlock(): boolean {
        return (
            this.isShowFilterPart
            && (
                this.knowModel === YesNoChoice.YES
                || this.hasSelectedTypeTravail()
            )
        );
    }

    /**
     * Machine filter block expanded
     */
    public machineFilterBlockExpanded() {
        return this.isVisibleMachineFilterBlock() && this.isShowMachineFilters;
    }

    /**
     * Param comp freinage has choices
     */
    public computeFreinageBlockVisibility() {

        let numFreinageTrue: number = 0;
        let numFreinageFalse: number = 0;

        for (const rouleau of this._filteredRouleauxBuffer) {
            for (const arbreMachine of rouleau.arbreMachines) {
                if (arbreMachine.freinage) {
                    numFreinageTrue++;
                } else {
                    numFreinageFalse++;
                }
            }
        }

        this.hasParamFreinageChoices = numFreinageTrue > 0 && numFreinageFalse > 0;
    }

    /**
     * Param comp freinage block is visible
     */
    public isVisibleParamCompFreinageBlock(): boolean {
        console.log('$$$$$$$$$$$$$$$$$$$$$$$$$$$');
        console.log(this.isShowFilterPart);
        console.log(this.knowModel);
        console.log(this.userFilter.chassisFilter.isFilter);
        console.log(this.hasParamFreinageChoices);
        console.log('$$$$$$$$$$$$$$$$$$$$$$$$$$$');
        return (
            this.isShowFilterPart
            && this.knowModel > 0
            && this.userFilter.chassisFilter.isFilter
            && this.hasParamFreinageChoices
        );
    }

    /**
     * Param comp freinage block expanded
     */
    public paramCompFreinageBlockExpanded(): boolean {
        return this.isVisibleParamCompFreinageBlock() && this.isShowParamCompFreinageFilters;
    }

    /**
     * Conseil pertinance block expanded
     */
    public conseilPertinanceBlockExpanded(): boolean {
        return this.isVisibleMachineFilterBlock() && this.isShowConseilPertinanceFilters;
    }

    /**
     * Goto doc page
     */
    public gotoDoc(doc: Doc) {
        this.router.navigate(['/doc', doc.codeRouleau], {replaceUrl: true}).catch(() => {
        });
    }

    /**
     * Get Rouleau Property
     * @param rouleau
     * @param prop
     */
    public getRouleauProperty(rouleau: Rouleau, prop: string): string {
        // @ts-ignore
        return rouleau[prop];
    }


    public get knowModel(): YesNoChoice {
        return this._knowModel;
    }
    public set knowModel(v: YesNoChoice) {
        this._knowModel = v;
        this._userFilter.typeTravail = null;
        this.computeFilter();
    }

    public get isShowTypeTravailFilters(): boolean {
        return this._isShowTypeTravailFilters;
    }
    public set isShowTypeTravailFilters(v: boolean) {
        this._isShowTypeTravailFilters = v;
    }
    public get isShowMachineFilters(): boolean {
        return this._isShowMachineFilters;
    }
    public set isShowMachineFilters(v: boolean) {
        this._isShowMachineFilters = v;
    }
    public get isShowParamCompFreinageFilters(): boolean {
        return this._isShowParamCompFreinageFilters;
    }
    public set isShowParamCompFreinageFilters(v: boolean) {
        this._isShowParamCompFreinageFilters = v;
    }
    public get hasParamFreinageChoices(): boolean {
        return this._hasParamFreinageChoices;
    }
    public set hasParamFreinageChoices(v: boolean) {
        this._hasParamFreinageChoices = v;
    }
    public get isShowConseilPertinanceFilters(): boolean {
        return this._isShowConseilPertinanceFilters;
    }
    public set isShowConseilPertinanceFilters(v: boolean) {
        this._isShowConseilPertinanceFilters = v;
    }
}
